export default "__VITE_ASSET__DwiO1QYy__"